module.exports = __webpack_public_path__ + "img/mssql.9deeddc6.svg";